// Shared table primitives for the Administration panels. Kept local to the
// admin feature so the global `S` tokens stay focused on app-wide styles.

export const tableStyle: React.CSSProperties = {
  width: "100%",
  borderCollapse: "collapse",
  fontSize: 13.5,
};

export const th: React.CSSProperties = {
  textAlign: "left",
  padding: "8px 12px",
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  color: "#94a3b8",
  borderBottom: "1px solid #e6e9f0",
};

export const td: React.CSSProperties = {
  padding: "10px 12px",
  borderBottom: "1px solid #f1f4f9",
  verticalAlign: "top",
};
